import type { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies';
import { StockItem } from 'search-gateway-client';

import { ClickLabel } from '@videoblocks/events-ts/lib/storyblocks/content/ClickLabelEnum';

import KafkaRestClient from '../kafka/KafkaRestClient';
import { StockItemClickEventFactory } from './StockItemClickEventFactory';

interface PublishEventOptions {
    cookies: ReadonlyRequestCookies;
    stockItem: StockItem;
    position: number;
    clickLabel: string;
    referrer: URL | undefined;
    currentUrl: URL;
    headers: Headers;
}

async function publishEvent(args: PublishEventOptions): Promise<void> {
    const { cookies, stockItem, position, clickLabel, referrer, currentUrl, headers } = args;
    const visitorIdCookie = cookies.get('VID')?.value ?? null;
    const loginSessionToken = cookies.get('login_session')?.value;
    const searchIdCookie = cookies.get('SSLID')?.value ?? null;
    const searchPageIdCookie = cookies.get('SGUID')?.value ?? null;

    const event = await StockItemClickEventFactory.create({
        searchIdCookie,
        searchPageIdCookie,
        currentUrl,
        headers,
        referrer,
        visitorCookieId: visitorIdCookie,
        stockItem,
        position,
        clickLabel: clickLabel as keyof typeof ClickLabel,
        sessionToken: loginSessionToken,
    });

    await KafkaRestClient.produce(event);
}

export const StockItemClickService = { publishEvent };
